<template>
  <div class="index">
    <el-popover
      popper-class="user-hover"
      ref="popover_user"
      placement="bottom"
      width="150"
      trigger="hover"
      v-model="user_hover"
    >
      <a class="user" target="_blank" href="https://www.kugou.com/newuc/user/uc/">个人账号</a>
      <a class="logout" href="https://www.kugou.com/newuc/login/outlogin">退出登录</a>
    </el-popover>
    <el-popover
      popper-class="kf-hover"
      ref="popover_kf"
      placement="bottom"
      width="430"
      trigger="hover"
      v-model="kf_hover"
    >
      <div class="kf-box">
        <p class="kf-title">CUSTOMER SERVICE</p>
        <p class="kf-tip">
          如您有任何疑问，可咨询
          <br />酷狗QQ在线客服：
          <span style="color: #5192fe;font-size: 18px;">800061578</span>
        </p>
        <div class="kf-qrcode">
          <img src="../assets/img/kf_qrcode.png" alt srcset />
          <p>请用QQ扫码</p>
        </div>
      </div>
    </el-popover>
    <header>
      <div class="logo center-y">
        <img src="../assets/img/logo.png" alt srcset />
        <span class="center-y">Remix</span>
      </div>
      <div class="kf" v-popover:popover_kf>联系客服</div>
      <div class="login-box" v-popover:popover_user>
        <img class="head-img" :src="globalParam.Pic" alt srcset />
        <span class="name">{{globalParam.NickName}}</span>
      </div>
    </header>
    <article>
        <ul class="tab">
            <li v-for="(item, i) in tab" :key="i" @click="gotoTab(item.tabName)" :class="activeTab==item.tabName ? 'active' : ''">
                <i :class="`${item.className} ${activeTab==item.tabName ? `${item.className}-hl` : ''}`"></i>
                <span>{{item.label}}</span>
            </li>
        </ul>
        <div class="main">
            <router-view></router-view>
        </div>
    </article>
  </div>
</template>

<script>
export default {
  mounted() {
    console.log(this.globalParam);
    console.log(this.$route)
    //根据路由重置activeTab
    this.activeTab = this.$route.path.split('/')[1]
  },
  methods: {
      gotoTab(tabName) {
          this.activeTab = tabName
          this.$router.push(`/${tabName}`)
      }
  },
  data() {
    return {
      activeTab: 'home',
      user_hover: false,
      kf_hover: false,
      tab: [{
          label: '个人主页',
          tabName: 'home',
          className: 'icon icon-main-page'
      },{
          label: '作品管理',
          tabName: 'work',
          className: 'icon icon-works'
      },{
          label: '任务中心',
          tabName: 'mission',
          className: 'icon icon-mission'
      },{
          label: '权益兑换',
          tabName: 'right',
          className: 'icon icon-right'
      }]
    };
  },
};
</script>

<style lang="scss" scoped>
.user-hover {
  a {
    display: block;
    color: #666;
    width: 150px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    text-align: center;
    &:hover {
      background-color: #f4f4f4;
    }
  }
  .user {
    background: url("https://staticssl.kugou.com/public/root/images/user_icon1.png")
      no-repeat 10px center;
  }
  .logout {
    background: url("https://staticssl.kugou.com/public/root/images/user_icon2.png")
      no-repeat 10px center;
  }
}
.kf-hover {
  .kf-box {
    width: 430px;
    height: 167px;
    background: #fff;
    border-radius: 10px;
    position: relative;
    .kf-title {
      position: absolute;
      color: #888888;
      top: 30px;
      left: 20px;
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      &::before {
        content: "";
        width: 30px;
        height: 4px;
        position: absolute;
        top: -10px;
        left: 0px;
        background-color: #0090ff;
      }
    }
    .kf-tip {
      color: #333333;
      position: absolute;
      line-height: 1.5;
      top: 70px;
      left: 20px;
      font-size: 18px;
    }
    .kf-qrcode {
      position: absolute;
      right: 20px;
      top: 20px;
      img {
        width: 100px;
        height: 101px;
      }
      p {
        position: absolute;
        top: 110px;
        color: #999999;
        font-size: 14px;
        width: 100%;
        text-align: center;
        line-height: 1;
      }
    }
  }
}
.index {
  header {
    width: 100%;
    height: 80px;
    background-color: #000;
    position: relative;
    color: #fff;
    .logo {
      width: auto;
      height: 34px;
      line-height: 34px;
      left: 20px;
      img {
        width: 130px;
        height: 34px;
      }
      span {
        color: #fff;
        margin-left: 10px;
        padding-left: 10px;
        &::before {
          content: "";
          position: absolute;
          width: 1px;
          height: 20px;
          top: 7px;
          background-color: #fff;
          left: 0;
        }
      }
    }
    .login-box {
      height: 50px;
      line-height: 50px;
      position: relative;
      float: right;
      width: auto;
      margin-top: 15px;
      cursor: pointer;
      .head-img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        //border: 1px solid #fff;
      }
      .name {
        color: #fff;
        font-size: 16px;
        display: inline-block;
        width: auto;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-left: 10px;
      }
    }
    .kf {
      height: 30px;
      line-height: 30px;
      float: right;
      font-size: 18px;
      position: relative;
      padding-left: 20px;
      margin: 25px 20px 0;
      cursor: pointer;
      &::before {
        content: "";
        position: absolute;
        width: 1px;
        height: 18px;
        top: 6px;
        background-color: #fff;
        left: 0;
      }
    }
  }
  > article {
      height: calc(100vh - 120px);
      margin-top: 20px;
      padding: 0 20px;
      display: flex;
      .tab {
          flex-basis: 260px;
          height: 100%;
          background-color: #fff;
          border-radius: 10px;
          margin-right: 20px;
          li {
              font-size: 16px;
              color: #333333;
              height: 50px;
              line-height: 50px;
              padding-left: 20px;
              position: relative;
              cursor: pointer;
              .icon {
                  margin-right: 15px;
              }
            &:first-child {
                margin-top: 15px;
            }
          }
          .active {
            color: #0090ff;
            &::before {
              content: '';
              position: absolute;
              width: 5px;
              height: 40px;
              background-color: #0090ff;
              left: 0;
              top: 5px;
            }
          }
      }
      .main {
          flex-grow: 1;
          height: 100%;
          background-color: #fff;
          border-radius: 10px;
      }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/Index.vue